import { Component, OnInit } from '@angular/core';
import {TypeSafeForm} from "../../../../shared/entities/src/lib/definitions/forms/type-safe-form-builder";
import {ILocationProductPricingTier} from "@boma/supplier-portal/shared/entities";
import {FormBuilder} from "@angular/forms";

export class LocationProductPricingForm extends TypeSafeForm<ILocationProductPricingTier>{
  constructor(fb: FormBuilder, initial: Partial<ILocationProductPricingTier>) {
    super(fb, initial);
  }
}

@Component({
  selector: 'boma-location-product-pricing-add-or-update',
  templateUrl: './location-product-pricing-add-or-update.component.html',
  styleUrls: ['./location-product-pricing-add-or-update.component.scss']
})
export class LocationProductPricingAddOrUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
